import { getSNSAddress } from './getSNSAddress.js';
export async function resolveSolanaAddress(name) {
    return await getSNSAddress(name);
}
//# sourceMappingURL=resolveSolanaAddress.js.map